import { useTranslation } from "react-i18next";
import SideBarItemList from "./SideBarItemList";
import { useSettings } from "context/SettingsContext";
import { useAuth } from "context/AuthContext";
import { hasUserAccess } from "utils/helpers/access/hasUserAccess";
import { isActiveTeamWarehouse } from "utils/helpers/teams/isTeamActive";
import useSettingsParams from "hooks/useSettingsParams";
import SolarInboxLineLinear from "../icons/SolarInboxLineLinear";
import SolarAddFolderLinear from "../icons/SolarAddFolderLinear";
import SolarHome2Linear from "../icons/SolarHome2Linear";
import SolarTrashBinMinimalisticLinear from "../icons/SolarTrashBinMinimalisticLinear";
import SolarFolderLinear from "../icons/SolarFolderLinear";
import SolarLockKeyholeMinimalisticLinear from "../icons/SolarLockKeyholeMinimalisticLinear";
import SolarUsersGroupRoundedLinear from "../icons/SolarUsersGroupRoundedLinear";

const SideBarWarehouses = ({ onOpenCreateTeam, onOpenCreateCustom }) => {
    const { t } = useTranslation();
    const { localSettings } = useSettings();
    const { auth } = useAuth();
    const params = useSettingsParams();

    const canCreateTeam = hasUserAccess(auth?.user, "teamsEdit");
    const customEnabled = Boolean(params.customWarehouses);

    const wReserve =
        localSettings?.WAREHOUSES?.filter((w) => w.reservObjectId > 0)
            ?.sort((a, b) => Number(b.objectCreated || 0) - Number(a.objectCreated || 0))
            ?.map((w) => ({
                label: w.objectName || w.clientName || `#${w.reservObjectId}`,
                to: `/warehouse/${w.ID}`,
            })) || [];

    const wCustom =
        customEnabled
            ? localSettings?.WAREHOUSES?.filter(
                  (w) => Number(w.customId) > 0 && !Number(w.customDeleted),
              )
                  ?.sort((a, b) => String(a.customName || "").localeCompare(String(b.customName || "")))
                  ?.map((w) => ({
                      label: w.customName || `#${w.customId}`,
                      to: `/warehouse/${w.ID}`,
                  })) || []
            : [];

    const wTeam =
        localSettings?.WAREHOUSES?.filter((w) => w.teamId > 0 && isActiveTeamWarehouse(w, localSettings?.DIRS?.Team))
            ?.sort((a, b) => {
                const ordA = localSettings?.DIRS?.Team?.find((t) => t.ID === a.teamId)?.teamOrd ?? 0;
                const ordB = localSettings?.DIRS?.Team?.find((t) => t.ID === b.teamId)?.teamOrd ?? 0;
                return Number(ordB) - Number(ordA);
            })
            ?.map((w) => ({
            label: w.teamName,
            to: `/warehouse/${w.ID}`,
        })) || [];

    const teamChildren = [
        ...wTeam,
        ...(canCreateTeam
            ? [
                  {
                      label: t("SideBarUl.itemWarehousesAddTeam"),
                      onClick: onOpenCreateTeam,
                      icon: <SolarAddFolderLinear />,
                  },
              ]
            : []),
    ];

    const customChildren = [
        ...wCustom,
        ...(canCreateTeam && customEnabled
            ? [
                  {
                      label: t("SideBarUl.itemWarehousesAddCustom"),
                      onClick: onOpenCreateCustom,
                      icon: <SolarAddFolderLinear />,
                  },
              ]
            : []),
    ];

    const itemsList = [
        { label: t("SideBarUl.itemWarehouses0"), to: "/warehouse/1", icon: <SolarHome2Linear /> },
        { label: t("SideBarUl.itemWarehouses1000"), to: "/warehouse/1000", color: "danger", icon: <SolarTrashBinMinimalisticLinear /> },
        ...(customEnabled
            ? [{ label: t("SideBarUl.itemWarehousesCustom"), icon: <SolarFolderLinear />, children: customChildren }]
            : []),
        ...(wReserve.length
            ? [{ label: t("SideBarUl.itemWarehousesReserve"), icon: <SolarLockKeyholeMinimalisticLinear />, children: wReserve }]
            : []),
        { label: t("SideBarUl.itemWarehousesTeams"), icon: <SolarUsersGroupRoundedLinear />, children: teamChildren },
    ];

    return (
        <SideBarItemList
            title={t("SideBarUl.itemWarehouses")}
            icon={<SolarInboxLineLinear />}
            iconClass="pc-micon--warehouses"
            itemsList={itemsList}
        />
    );
};

export default SideBarWarehouses;
